import React, { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import styles from './relatedProductsCarousel.module.css';
import { ProductCard } from '../../ui/productCard/ProductCard'

export function RelatedProductsCarousel({ data }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    skipSnaps: true,
    align: "start",
  });

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const updateScrollStates = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;

    updateScrollStates();

    emblaApi.on('select', updateScrollStates);
    emblaApi.on('reInit', updateScrollStates);

    return () => {
      emblaApi.off('select', updateScrollStates);
      emblaApi.off('reInit', updateScrollStates);
    };
  }, [emblaApi, updateScrollStates]);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className={styles.embla}>
      <div className={styles.embla__viewport} ref={emblaRef}>
        <div className={styles.embla__container}>
          {data?.map((item, index) => (
            <div key={item.id} className={styles.embla__slide}>
              <ProductCard product={item} />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.embla__button__container}>
        <button
          className={`${styles.embla__button} ${styles.embla__button__left} ${canScrollPrev ? styles.active : ''
            }`}
          onClick={scrollPrev}
        ></button>
        <button
          className={`${styles.embla__button} ${styles.embla__button__right} ${canScrollNext ? styles.active : ''
            }`}
          onClick={scrollNext}
        ></button>
      </div>
    </div>
  );
}
